<template>
  <div id="app">
    <vue-glide :perView="1">
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_1.jpg" alt />
          <div class="slide_text">
            <h2>Step 1. Get started</h2>
            <p>Call us for a free consultation with our debt specialist.</p>
          </div>
        </div>
      </vue-glide-slide>
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_2.jpg" alt />
          <div class="slide_text">
            <h2>Step 2. Submit your documents <br> and your application</h2>
            <p>All we need is your lending agreement, 6 months <br> of bank statements, and the filled-out our application form.</p>
          </div>
        </div>
      </vue-glide-slide>
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_3.jpg" alt />
          <div class="slide_text">
            <h2>Step 3. Get our expert’s <br> conclusion on your file</h2>
            <p>Schedule a call and discuss your contract <br> terms with one of our senior advisors.</p>
          </div>
        </div>
      </vue-glide-slide>
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_4.jpg" alt />
          <div class="slide_text">
            <h2>Step 4. Agreement signing</h2>
            <p>Negotiate the details and sign an agreement.</p>
          </div>
        </div>
      </vue-glide-slide>
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_5.jpg" alt />
          <div class="slide_text">
            <h2>Step 5. Get underwriting approval</h2>
            <p>Submit additional information or documents if required.</p>
          </div>
        </div>
      </vue-glide-slide>
      <vue-glide-slide>
        <div class="slide_block">
          <img src="../assets/slide_6.jpg" alt />
          <div class="slide_text">
            <h2>Step 6. Settlement savings</h2>
            <p>We will devise a new more manageable payment <br> plan so you can fully focus on your business.</p>
          </div>
        </div>
      </vue-glide-slide>

      <template slot="control">
        <b-button variant="primary" data-glide-dir="<">
          <b-icon icon="arrow-left"></b-icon>
        </b-button>
        <b-button variant="primary" data-glide-dir=">">
          <b-icon icon="arrow-right"></b-icon>
        </b-button>
      </template>
    </vue-glide>
  </div>
</template>

<script>
import { Glide, GlideSlide } from "vue-glide-js";

export default {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide
  }
};
</script>

<style lang="scss">
.slide_block {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  img {
    width: 100%;
    max-width: 500px;
  }
  .slide_text {
    text-align: center;
  }
}
div[data-glide-el="controls"] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  button {
    padding: 0 20px;
    font-size: 34px;
    border-radius: 0;
  }
}
</style>